import {
  Controller
} from "@hotwired/stimulus";

export default (class extends Controller {
  connect() {
    return this.element.textContent = "Hello World!";
  }

});
